import { Table, Button, Space, Card, message, Skeleton, Col, Row, Popconfirm, Switch, Modal, Tag } from 'antd';
import { parameterset, scanmaster, updatedata } from '../typing/table_typing';
import { Component, Key } from 'react';
import { cardmargin, grayheader } from '../../CSSReferences';
import { UserOutlined } from '@ant-design/icons';
import { archivableSelection, compareText, compareVersion, isArchived, majorFilters, majorOf, mayArchive, predecessorLabel, visibleRows } from './update_columns';
import { injectIntl, WrappedComponentProps } from '../../../intl-compat';

// DbEnum.SoftwareStatus im Hub: buggy=5, nightly=10, alpha=20, beta=30,
// release=40. Der Hub liefert die Zahl, die Spalte soll den Namen zeigen.
const ZWEIGNAME: Record<number, string> = {
  5: 'buggy',
  10: 'nightly',
  20: 'alpha',
  30: 'beta',
  40: 'release',
};

export interface TableThingyMainProps extends WrappedComponentProps{
  data:updatedata[],
  view:{
    loaded: boolean, 
    autorefresh: boolean,
  }
  scanmasterlist:string,//scanmaster[],
  onLoadRequested:()=>void;
  onDeleteRequested:(item:string)=>void;
  onMySubmit: (uuid:string) => void;
  onDeactivate: (uuid:string) => void;
  onArchive: (uuids:readonly string[], conflictText:string) => void;
  onRestore: (uuid:string) => void;
  onScanRequested:(targetuuid:string, scanmasteruuid:string, parameter:parameterset)=>void;
}

interface TableThinyViewInnerState{
      filteredInfo:any, 
      sortedInfo:any,   
      visible: boolean,
      condition: boolean,
      itemToDelete:string, 
      scanmaster:string, 
      parameterlist:string,
      showArchived:boolean,
      selected:string[],
    }


class UpdatesTableView extends Component<TableThingyMainProps, TableThinyViewInnerState> 
{
    constructor(props:TableThingyMainProps){
      super(props);
       this.state = {
         filteredInfo: null,
         sortedInfo: null,
          visible: true,// data.user.map((x:userdata) => {return false}),
          scanmaster: '',//user.map((x:userdata) => {return "x"}),
          parameterlist: '',
          condition:false,
          itemToDelete:'',
          showArchived:false,
          selected:[],
     }
    }

    componentWillReceiveProps(){
    this.setState({
      // visible: this.props.data.user.map((x:userdata) => {return false}),
      // scanmaster: this.props.data.user.map((x:userdata) => {return "x"}),
      // // if thiny != x do not touch
      // parameterlist: this.props.data.user.map((x:userdata) => {
      //   return {
      //     startdate : "",
      //     interval : 28,
      //     status : "",
      //     tags : "",
      //     targettype : "",
      //     credentialsgroup: "",
      //   }
      // }),
    })
  }
  

    componentDidMount(){
       setTimeout(() => {
        //setInterval(() => {
         // console.log(Date.now());
        this.props.onLoadRequested()
      }, 400);
      
      // this.props.onButtonClicked();
    }

    OnDeleteButtonPressed(item:string){
      console.log(item +"will be deleted")
      //this.props.onDeleteRequested(item)
    }
   
    MyOnSubmit = async (uuid:any) => {
      this.props.onMySubmit(uuid);
      
    };

    handleChange = (pagination:any, filters:any, sorter:any) => {
        this.setState({
          filteredInfo: filters,
          sortedInfo: sorter,
        });
      };
    

  handleVisibleChange = (visible:any, clickedElementIndex:number, uuid:string) => {
    // if (!visible) {
    //   this.setState({  visible:this.state.visible.map((elem:boolean, index:number) =>{
    //     return index===clickedElementIndex? !this.state.visible[index]:this.state.visible[index]
    //   } )  });
    //   return;
    // }
    // // Determining condition before show the popconfirm.
    // if (this.state.condition) {
    //   this.confirm(clickedElementIndex, uuid); // next step
    // } else {
    //   this.setState({ visible:this.state.visible.map((elem:boolean, index:number) =>{
    //     return index===clickedElementIndex? !this.state.visible[index]:this.state.visible[index]
    //   } )  }); // show the popconfirm
    // }
  };

  changeCondition = (value:any) => {
    this.setState({ condition: value });
  };

  private _scan = (targetuuid: string, targetIP: string, scanmasteruuid: string, scanmastername: string) => {
    if (scanmasteruuid === "x") {
      message.error(targetIP + " has no Scan defined");
    }

    else {
      

      message.success(targetIP + " will be scanned " + this.showScanname(scanmasteruuid));

    }
  };
  public get scan_1() {
    return this._scan;
  }
  public set scan_1(value) {
    this._scan = value;
  }
  public get scan() {
    return this._scan;
  }
  public set scan(value) {
    this._scan = value;
  }

  setScanState = (clickedElementIndex:number, uuid:string) => {
    console.log(clickedElementIndex, uuid)
    // this.setState({ scanmaster:this.state.scanmaster.map((elem:string, index:number) =>{
    //   return index===clickedElementIndex? uuid : this.state.scanmaster[index]
    //   } ) });
  }

  showScanname =(input:string) =>
  {
    // var item = this.props.scanmasterlist.find(myObj => myObj.uuid===input);
    // if (item !== undefined)
    // {
    //   return item.description
    // }
    // else
    // {
    //   return "None"
    // }
  }

  confirm = (clickedElementIndex:number, uuid:string) => {
    // this.setState({ visible:this.state.visible.map((elem:boolean, index:number) =>{
    //   return index===clickedElementIndex? !this.state.visible[index]:this.state.visible[index]
    // } ) });
    // message.success(uuid +" will be deleted");
    // this.props.onDeleteRequested(uuid)
  };

  cancel = (clickedElementIndex:number) => {
    // this.setState({ visible:this.state.visible.map((elem:boolean, index:number) =>{
    //   return index===clickedElementIndex? !this.state.visible[index]:this.state.visible[index]
    // } )  });
    // message.error('Click on cancel.');
  };

      clearFilters = () => {
        this.setState({
        filteredInfo: null,
      });
      };
    
      clearAll = () => {
        this.setState({
          filteredInfo: null,
          sortedInfo: null,
        });
      };
    
      setAgeSort = () => {
        this.setState({
          sortedInfo: { 
            order: 'descend',
            columnKey: 'ipv4',
          },
        });
      };
    
      handleMenuClick(e:any) {
        // message.info('Click on menu item.', e);
        // console.log('click', e);
      }


      /**
       * Die Eintraege der Auswahl - als Daten, wie antd 6 sie erwartet.
       *
       * Der zugehoerige <Dropdown> fehlt in dieser Ansicht; die Liste wird
       * derzeit nirgends angezeigt. Mitgezogen, damit sie beim Wiederbeleben
       * nicht in einer abgekuendigten Form dasteht. Der <Button> um jeden
       * Eintrag entfaellt - er trug nur den onClick.
       */
      getScanmaster(scanmaster:scanmaster[], recordID:number){
        let returnvalue: any[] = []
        returnvalue.push({
          key: recordID + 'x',
          icon: <UserOutlined />,
          label: "None",
          onClick: () => { this.setScanState(recordID, 'x') },
        })
        for (let item in scanmaster)
        {
          returnvalue.push({
            key: recordID + scanmaster[item].uuid,
            icon: <UserOutlined />,
            label: scanmaster[item].description,
            onClick: () => { this.setScanState(recordID, scanmaster[item].uuid) },
          })
        }
        return returnvalue;
      }

  /** Message text by id (de.js / en.js). */
  t = (id:string, values?:Record<string, string|number>) =>
    this.props.intl.formatMessage({ id, defaultMessage: id }, values);

  /** Asks before archiving the selected releases, listing their versions, then archives them all at once. */
  confirmArchiveSelected = () => {
    const rows = archivableSelection(this.props.data, this.state.selected);
    if (rows.length === 0) return;
    Modal.confirm({
      title: this.t("Updates:ArchiveSelectedConfirm", { count: rows.length }),
      content: <ul>{rows.map((r) => <li key={r.uuid}>{r.software} {r.version}</li>)}</ul>,
      okText: this.t("Updates:Archive"),
      cancelText: this.t("Updates:Cancel"),
      onOk: () => {
        this.props.onArchive(rows.map((r) => r.uuid), this.t("Updates:MustDeactivate"));
        this.setState({ selected: [] });
      },
    });
  };

render(){
  let { sortedInfo, filteredInfo } = this.state;
    sortedInfo = sortedInfo || {};
    filteredInfo = filteredInfo || {};
    const sortOrderOf = (key:string) => (sortedInfo.columnKey === key ? sortedInfo.order : null) || null;
    const predecessor = predecessorLabel(this.props.data);
    const selectable = archivableSelection(this.props.data, this.state.selected);
    
    const columns = [
      {
        title: 'Update #',
        dataIndex: 'uuid',
        key: 'uuid',
        sorter: (a:updatedata, b:updatedata) => compareText(a.uuid, b.uuid),
        sortOrder: sortOrderOf('uuid'),
        ellipsis: false,
      },
      {
        title: 'Client',
        dataIndex: 'software',
        key: 'software',
        filters: [...new Set(this.props.data.map((r) => r.software).filter(Boolean))].sort().map((c) => ({ text: c, value: c })),
        filteredValue: filteredInfo.software || null,
        onFilter: (value:any, record:updatedata) => record.software === value,
        sorter: (a:updatedata, b:updatedata) => compareText(a.software, b.software),
        sortOrder: sortOrderOf('software'),
        ellipsis: false,
      },
      {
        title: 'Version',
        dataIndex: 'version',
        key: 'version',
        filters: majorFilters(this.props.data),
        filteredValue: filteredInfo.version || null,
        onFilter: (value:any, record:updatedata) => majorOf(record.version) === value,
        sorter: (a:updatedata, b:updatedata) => compareVersion(a.version, b.version),
        sortOrder: sortOrderOf('version'),
        ellipsis: false,
        render: (version:string, record:updatedata) =>
          isArchived(record) ? <>{version} <Tag>{this.t("Updates:ArchivedTag")}</Tag></> : version,
      },

      {
        title: 'Branch',
        dataIndex: 'branch',
        key: 'branch',
        // branch ist eine Zahl; .length darauf ergibt undefined und der
        // Vergleich NaN - sortiert wurde damit nie.
        sorter: (a:any, b:any) => (a.branch ?? 0) - (b.branch ?? 0),
        sortOrder: sortOrderOf('branch'),
        ellipsis: false,
        // Der zweite Parameter ist die ganze Zeile, der erste der Wert der
        // Spalte. Verglichen wurde bisher die Zeile mit 40, 30, 20 - das trifft
        // nie zu, und der Standardzweig gab die Zeile selbst zurueck. Die
        // Spalte blieb deshalb leer, obwohl der Wert da war.
        render: (text:any) => ZWEIGNAME[text as number] ?? (text ?? ''),
      },

       {
        title: 'File',
        dataIndex: 'file',
        key: 'file',
        sorter: (a:updatedata, b:updatedata) => compareText(a.file, b.file),
        sortOrder: sortOrderOf('file'),
        ellipsis: false,
      },
      {
        // The predecessor is shown by its version (the id on hover) and
        // sorted by what is shown; empty for the first release of a chain.
        title: 'Predecessor',
        dataIndex: 'precessor',
        key: 'precessor',
        render: (precessor:string) => <span title={precessor || undefined}>{predecessor(precessor)}</span>,
        sorter: (a:updatedata, b:updatedata) => compareVersion(predecessor(a.precessor), predecessor(b.precessor)),
        sortOrder: sortOrderOf('precessor'),
        ellipsis: false,
      },
      {
        title: 'Action',
        key: 'action',
        render: (text:any, record:any) =>{
          // const recordID = this.props.data.user.findIndex((x:userdata) => {
          //   return x.uuid===record.uuid
          // })
          if (isArchived(record))
          {
            // Archived (since 08.10.2026): only restoring is offered; activate
            // after restoring.
            return(
              <Button size="middle" onClick={() => this.props.onRestore(record.uuid)}>{this.t("Updates:Restore")}</Button>
            );
          }
          if (record.active === 0)
          {
          return(
            <Space>
                 <Button htmlType="submit" size="middle" onClick={() => this.MyOnSubmit(record.uuid)}> activate</Button>
                 <Popconfirm
                   title={this.t("Updates:ArchiveConfirm", { version: record.version })}
                   description={this.t("Updates:ArchiveHint")}
                   okText={this.t("Updates:Archive")}
                   cancelText={this.t("Updates:Cancel")}
                   onConfirm={() => this.props.onArchive([record.uuid], this.t("Updates:MustDeactivate"))}
                 >
                   <Button size="middle">{this.t("Updates:Archive")}</Button>
                 </Popconfirm>
            </Space>
          );
          }
          else
          {
            // Withdraw an active release (since 01.10.2026); asks first, because
            // spokes stop being offered it right away.
            return(
              <Popconfirm
                title="Deactivate this release?"
                description="Spokes will no longer be offered it. You can activate it again later."
                okText="Deactivate"
                cancelText="Cancel"
                onConfirm={() => this.props.onDeactivate(record.uuid)}
              >
                <Button danger size="middle">deactivate</Button>
              </Popconfirm>
            );
          }
        },
      },
    ];

    

    if (this.props.view.loaded === false)
    {
      return (
        <div>
          <Card title="Updates" style={cardmargin}  hoverable styles={{ header: grayheader }}>
          <Skeleton active />
          </Card>
          </div>
      )    
    }
    else
    {
  return (
    <div>
       <Card title={"Updates center"} style={cardmargin} hoverable styles={{ header: grayheader }}>
    <Row gutter={16} style={{ marginBottom: 16 }}>
      <Col span={24}>
        <Space wrap>
          <Space>
            <Switch checked={this.state.showArchived}
                    onChange={(showArchived:boolean) => this.setState({ showArchived })} />
            {this.t("Updates:ShowArchived")}
          </Space>
          <Button disabled={selectable.length === 0} onClick={this.confirmArchiveSelected}>
            {this.t("Updates:ArchiveSelected")}{selectable.length > 0 ? " (" + selectable.length + ")" : ""}
          </Button>
        </Space>
      </Col>
    </Row>
    <Table rowKey="uuid" pagination={{position: ['topCenter', 'bottomCenter'] }} columns={columns}
           dataSource={visibleRows(this.props.data, this.state.showArchived)} onChange={this.handleChange}
           rowSelection={{
             selectedRowKeys: this.state.selected,
             onChange: (keys:Key[]) => this.setState({ selected: keys.map(String) }),
             getCheckboxProps: (record:updatedata) => ({ disabled: !mayArchive(record) }),
           }}
           onRow={(record:updatedata) => isArchived(record) ? { style: { color: '#8c8c8c', fontStyle: 'italic' } } : {}} /> 
    </Card> 
    </div>
  )}
}
}

export const TThingyView = injectIntl(UpdatesTableView);
